var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4644_3456)",
    filter: "url(#filter0_dii_4644_3456)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.0951 64.8121C79.8615 65.6697 83.6254 68.3705 85.1614 76.0121C85.8781 79.5446 86.3392 81.8484 86.6464 83.3459C86.8384 84.3315 86.5946 85.3304 86.0314 86.0984C83.5356 85.548 81.2445 84.3063 79.4014 82.4634C76.8543 79.9035 75.4465 76.4982 75.4464 72.8759C75.4464 69.9321 76.3674 67.1288 78.0951 64.8121Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.9889 51.6659C94.6591 51.666 99.9839 53.8809 103.99 57.8871C107.996 61.8935 110.21 67.2056 110.21 72.8759C110.21 78.5461 107.996 83.8708 103.99 87.8771C99.8559 92.0114 94.4287 94.0845 88.9889 94.0846C84.2018 94.0846 79.4141 92.4724 75.5101 89.2596L72.2201 92.5496C72.796 93.3048 72.7453 94.4182 72.0414 95.1221L56.0539 111.122C55.3243 111.864 54.3513 112.223 53.3914 112.223C52.4315 112.223 51.4838 111.864 50.7414 111.122C49.2696 109.65 49.2696 107.282 50.7414 105.81L66.7414 89.8096C67.1125 89.4385 67.6248 89.2335 68.1239 89.2334C68.5463 89.2334 68.9695 89.3746 69.3151 89.6434L72.6039 86.3534C69.4811 82.5648 67.779 77.8547 67.7789 72.8759C67.7789 67.2183 69.9937 61.8935 74.0001 57.8871C78.0065 53.8808 83.3186 51.6659 88.9889 51.6659ZM88.9751 56.2734C84.5465 56.2735 80.3863 58.0025 77.2376 61.1384C74.1019 64.2743 72.3864 68.4345 72.3864 72.8759C72.3865 77.3173 74.1018 81.4775 77.2376 84.6134C80.4759 87.8517 84.7129 89.4645 88.9751 89.4646C93.2374 89.4646 97.4871 87.8515 100.713 84.6134C103.861 81.4775 105.578 77.3046 105.578 72.8759C105.578 68.4471 103.861 64.2744 100.713 61.1384C97.5767 58.0024 93.4039 56.2734 88.9751 56.2734Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1889 60.3834C65.9362 64.1081 64.7326 68.3963 64.7326 72.8634C64.7328 77.6245 66.0633 82.1297 68.6101 86.0334L68.4439 86.2009H68.1239C66.8057 86.201 65.5257 86.7253 64.5914 87.6596L61.3914 90.8596L61.3789 90.8471C60.2141 90.8727 59.0358 90.8846 57.8326 90.8846H48.1301C37.852 90.8846 28.6871 89.9632 21.5576 87.3009C19.9451 86.6992 18.9984 85.0228 19.3439 83.3334C19.6511 81.8358 20.1121 79.5312 20.8289 75.9984C22.877 65.874 28.8289 64.4271 28.8289 64.4271L40.9114 58.9746L48.1439 82.7446L50.7039 70.2009H55.2989L57.8464 82.7446L65.0776 58.9746L68.1889 60.3834Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0776 64.9271L55.3376 68.9721H50.6526L48.9114 64.9271L49.9351 63.1859H56.0664L57.0776 64.9271Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9951 16.2996C53.0816 16.2933 66.6675 15.1449 67.8039 28.2159C68.0215 30.6607 67.5101 35.4234 67.5101 35.4234C67.5324 35.4246 69.0847 35.5155 69.2501 37.7134C69.4165 39.9278 69.1478 44.9073 65.4614 47.0321C65.4614 47.0321 63.286 58.5006 52.9951 58.5009C42.7039 58.5009 40.5276 47.0321 40.5276 47.0321C36.8413 44.9073 36.5725 39.9278 36.7389 37.7134C36.9055 35.5124 38.4801 35.4234 38.4801 35.4234C38.4801 35.4234 37.9675 30.6607 38.1851 28.2159C39.3375 15.1092 52.9951 16.2996 52.9951 16.2996Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.7451 0.248383C66.2683 0.248383 67.7788 0.299433 69.2764 0.414633C102.505 2.73145 128.745 30.4308 128.745 64.2484C128.745 71.9924 127.363 79.4298 124.841 86.3034C115.856 110.777 92.3418 128.248 64.7451 128.248C29.4043 128.248 0.745148 99.5892 0.745148 64.2484C0.745148 28.9076 29.4043 0.248383 64.7451 0.248383ZM64.7451 7.92838C43.2539 7.92838 24.5274 20.0373 15.0426 37.7909C10.8187 45.6885 8.42515 54.6868 8.42515 64.2484C8.42515 95.3012 33.6923 120.568 64.7451 120.568C87.5035 120.568 107.152 107 116.035 87.5184C119.261 80.4273 121.065 72.5426 121.065 64.2484C121.065 33.1956 95.7979 7.92838 64.7451 7.92838Z",
    fill: "#00FFFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_4644_3456",
    x: 0.0000118613,
    y: 0.00000396371,
    width: 129.49,
    height: 130.32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.496757
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.372568
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4644_3456"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4644_3456",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.07148
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86284
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect2_innerShadow_4644_3456"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.07796
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.24189
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "soft-light",
    in2: "effect2_innerShadow_4644_3456",
    result: "effect3_innerShadow_4644_3456"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4644_3456"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    fill: "white",
    transform: "translate(0.745148 0.248383)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomer);
export default __webpack_public_path__ + "static/media/customer.b00cd721e2945821738788a7ad768e4e.svg";
export { ForwardRef as ReactComponent };